import { render, staticRenderFns } from "./FileTemplates.vue?vue&type=template&id=41985d1d&"
import script from "./FileTemplates.vue?vue&type=script&lang=js&"
export * from "./FileTemplates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports